export const percsTriptych = [
  {
    title: `A customized
    subscription`,
    paragraph:
      'Customize each product in your routine to arrive exactly when you want, so you’ll never go without your beauty routines. Pause deliveries, adjust your plan or cancel anytime with no hassle.',
  },
  {
    title: `The Prose
    Promise™`,
    paragraph:
      'Discover the difference of custom beauty — and love your first order (or it’s on us) with our 30-day money-back guarantee.',
  },
  {
    title: `Save 15%
    on every order`,
    paragraph:
      'When you subscribe to haircare and skincare, you’ll enjoy the same exclusive perks across both subscriptions, including 15% off + free shipping on every future order.',
  },
];
